import { scrollToElement } from "@client/lib/misc";
import { isNull } from "lodash";

export const getStatusColor = (isApproved: boolean | null): string => {
  if (isNull(isApproved)) return "var(--orange)";
  return isApproved ? "var(--green)" : "var(--red)";
};

export const getStatusIcon = (isApproved: boolean | null): string => {
  if (isNull(isApproved)) return "var(--orange)";
  return isApproved ? "var(--green)" : "var(--red)";
};

export const scrollToEl = (el: HTMLDivElement | null) => {
  if (el) {
    scrollToElement(el);

    el.querySelector("textarea")?.focus();
  }
};

export const getHtmlId = (id: string) => `pc_${id}`;
